import AccessPointButton from 'components/FrictionlessCheckout/DeliverToReleaseThree/AccessPoint/AccessPointButton/AccessPointButton';

import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import AccessPointButtonEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/AccessPoint/AccessPointButton/locales/AccessPointButton_en_US';
import AccessPointButtonFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/AccessPoint/AccessPointButton/locales/AccessPointButton_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(AccessPointButtonEN, AccessPointButtonFR);

const localizationSelector = createStructuredSelector({
    fedexPickupLabel: getTextFromResource(getText, 'fedexPickupLabel'),
    editLabel: getTextFromResource(getText, 'editLabel'),
    useThisAddress: getTextFromResource(getText, 'useThisAddress')
});

const withAccessPointButtonProps = wrapHOC(
    connect(
        createSelector(localizationSelector, localization => {
            return {
                localization
            };
        })
    )
);

export default withAccessPointButtonProps(AccessPointButton);
